import React, { useState, useEffect, useCallback } from 'react';
import PageContainer from '@CSIComponents/PageContainer';
import { Card, Button, Modal, message } from 'antd';
import { getOTACodes } from '../../../../../services/common';
import Loading from '../../../../Loading';
import AnTable from '../../../../AnTable';
import RateDetail from './RateDetail'
import {Rate, RatesApi} from './RatesTypes'
import { getHelper } from './helpers'
import { sortHelper } from '@helpers/misc/sortHelper'

interface PropsType {
    changeTab: () => void ,
    setRatesDetails: (e: object) => void,
    isEditable: () => void,
    cancelEditable: () => void,
    setOperationType: (e: string) => void,
    detailData: {policies:{ratepolicy: object[]}},
}


const Rates = (props: PropsType ) => {
    const [editLoading, setEditLoading] = useState(false);

    const [ratePlanType, setRatePlanType] = useState<Array<{key:string, codeName: string}>>([]);
    const [guestType, setGuestType] = useState<Array<{key:string, codeName: string}>>([]);

    const [mode, setMode] = useState<string>('')
    const [ detailViewOn, setDetailViewOn] = useState<boolean>(false)
    const [ rateList, setRateList ] = useState<Rate[]>([])
    const [ rate, setRate] = useState<Rate | object>({})

    const getTypeData = useCallback(async () => {
        let res = await getOTACodes('RPT', '')
        if (res && res.otacodes && res.otacodes.length != 0) {
            setRatePlanType(res.otacodes)
        }
        let response = await getOTACodes('GUE', '')
        if (response && response.otacodes && response.otacodes.length != 0) {
            setGuestType(response.otacodes)
        }
        setEditLoading(false)
    }, []);

    useEffect(() => {
        setRateList(props.detailData.policies.ratepolicy)
        setEditLoading(true)
        getTypeData();
    }, [])

    useEffect(() => {
        if(detailViewOn === false) {
            setRate({})
            props.setOperationType('view')
        }
    }, [detailViewOn])

    const getData = useCallback(async () => {
        setEditLoading(true)
        const resultData: RatesApi  = await getHelper('/property/policies')
        const resData = resultData.property?.policies.ratepolicy;
        setRateList(resData || [])
        setEditLoading(false)
    }, [])

    const update = () => {
        getData()
        setDetailViewOn(false)
    }

    if (editLoading) {
        return <Loading type="large" />
    }

    return (
    <> <PageContainer>

            { !detailViewOn ? 
                <Card style={{ marginTop: -15, marginBottom:65 }}>
                <div>
                    <div className="col-12">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '18px' }}>Rates</div>     
                            <Button style={{ background: '#004771', color: '#fff', width: 60, height: 28 }} 
                                onClick={() => {
                                    setMode('Add'); setDetailViewOn(true)
                                }}>
                                    Add
                            </Button>
                        </div>
                    </div>

                    <div className="col-12">
                        <AnTable
                                data = {rateList}
                                configuration = {[
                                    {
                                        title: '',
                                        key: 'index',
                                        render: (text: string, record: [], index: number) => index += 1,
                                        width: '40px'
                                    },
                                    { 
                                        title: 'Policy Name', dataIndex: 'name', key: 'name',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'name'), 
                                        showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Policy Type', dataIndex: 'policytype', key: 'policytype',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'policytype'), 
                                        showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Guest Type', dataIndex: 'guesttype', key: 'guesttype',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'guesttype'), 
                                        showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Minimum Room Nights Required', dataIndex: 'minimumnights', key: 'minimumnights',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'minimumnights'), 
                                        showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Corporate ID Required', dataIndex: 'corporateidrequired', key: 'corporateidrequired',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'corporateidrequired'), 
                                        showSorterTooltip: false
                                    },
                                ]}
                                onCLickRow = {(e ) => {
                                    setRate(e)
                                    setMode('Edit'); 
                                    props.setOperationType('edit')
                                    setDetailViewOn(true)
                                }} 
                                search= {{label: 'Search', placeholder: 'Search Rates'}}
                                />
                    </div>
                </div>
                </Card>
            : 
             
              <RateDetail 
                ratePlanType = {ratePlanType}
                guestType = {guestType}
                rate = {rate}
                mode = {mode}    
                setDetailViewOn = {setDetailViewOn} 
                setEditLoading = {setEditLoading}
                update = { update }
              />
            
            }

            
        </PageContainer>
        </>
    )
}


export default Rates;
